import clsx from "clsx";

interface EmptyStateCardProps {
    heading: string;
    body: string;
}

export function EmptyStateCard({ heading, body }: EmptyStateCardProps) {
    return (
        <div
            className={clsx("p-4", "flex flex-col", "gap-3 rounded")}
            style={{ backgroundColor: "#2E3849" }}
        >
            <h3 className="heading-s">{heading}</h3>
            <p className="body-s">{body}</p>
        </div>
    );
}
